export default __webpack_public_path__ + "static/media/leaf.74531192.svg";